import { createElement, useMemo } from 'react';
import classNames from 'classnames';
import { mergeProps } from '../../utils/with-default-props';
import ColorfulMask from '../colorful-mask';
import './index.scss';
const defaultProps = {
    visible: true,
    type: 'confirm',
    buttonType: 'default',
    showCloseButton: false,
    title: '提示',
    content: '右上角有个关闭的小图标，点击它也可已关闭弹窗。',
    okText: '我知道了',
    cancelText: '取消',
    onClose: () => { },
    onOk: () => { },
};
const ColorfulModal = function ColorfulSteps(p) {
    const props = mergeProps(defaultProps, p);
    const { visible, width, title, content, image, showCloseButton, maskClassName, closeOnMaskClick, footer, type, buttonType, okText, cancelText, onClose, onOk, ...otherProps } = props;
    const prefixCls = 'au-modal';
    const onMaskClick = () => {
        if (!closeOnMaskClick)
            return;
        if (type === 'confirm') {
            onClose();
        }
        else {
            onOk();
        }
    };
    const modalClick = (e) => {
        e.stopPropagation();
    };
    const isImageStr = useMemo(() => {
        return typeof image === 'string';
    }, [image]);
    return (createElement(ColorfulMask, { ...otherProps, visible: visible, maskClassName: maskClassName, onMaskClick: onMaskClick },
        createElement("div", { className: classNames(prefixCls), onClick: modalClick, style: { width } },
            createElement("div", { className: classNames(image ? `${prefixCls}-image` : '') },
                createElement("div", { className: classNames(image ? `${prefixCls}-image-inner` : '') }, image && isImageStr && createElement("img", { className: classNames(`${prefixCls}-image-inner-item`), src: image })),
                image && !isImageStr && image),
            showCloseButton && createElement("i", { className: classNames('icon-times', `${prefixCls}-close`), onClick: onClose }),
            title && (createElement("div", { className: classNames(`${prefixCls}-header`) }, title)),
            createElement("div", { className: classNames(`${prefixCls}-body`) }, content),
            createElement("div", { className: classNames(`${prefixCls}-footer`, `${prefixCls}-footer${footer ? '' : '-default'}`) },
                footer,
                !footer && footer !== null && type === 'confirm' && createElement("button", { className: classNames('au-btn', `${prefixCls}-btn-${buttonType}`, `${prefixCls}-btn-${buttonType}-cancel`), onClick: onClose }, cancelText),
                !footer && footer !== null && createElement("button", { className: classNames('au-btn', `${prefixCls}-btn-${buttonType}`), onClick: onOk }, okText)))));
};
ColorfulModal.displayName = 'ColorfulModal';
export default ColorfulModal;
